/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_GeocodingInputs */

const cs_import_progress_phase_geocoding = /** @type {(inputs: Import_Progress_Phase_GeocodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geokódování`)
};

const en_import_progress_phase_geocoding = /** @type {(inputs: Import_Progress_Phase_GeocodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geocoding`)
};

/**
* | output |
* | --- |
* | "Geocoding" |
*
* @param {Import_Progress_Phase_GeocodingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_geocoding = /** @type {((inputs?: Import_Progress_Phase_GeocodingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_GeocodingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_geocoding(inputs)
	return cs_import_progress_phase_geocoding(inputs)
});